import { Box } from "@chakra-ui/react"
import { Generator } from "./Generator"




export const QRGenreator = () => {


    return (
        <Box>
            <Generator />
        </Box>
    )
}